import React, { Component } from 'react'
import { Avatar, A, Div, ToolTip, IconButton } from '@driftt/tide-core'
import moment from 'moment'


class Controls extends Component {

  render() {
    const { segment, onSegmentSelect, onSegmentDelete } = this.props

    return (
      <Div className="contact-actions-cell">
        {
          "SALESFORCE" === segment.type ?
            <Div className="contact-actions-button contact-actions-view-details">
              <ToolTip flow="up" component={`Salesforce lists cannot be edited`}>
                <IconButton disabled="true" icon="edit-1" size="medium" inline={true} inlineStyle="subtle" />
              </ToolTip>
            </Div>
            :
            <Div className="contact-actions-button contact-actions-view-details" onClick={() => onSegmentSelect(segment.id)}>
              <ToolTip flow="up" component={`Edit segment`}>
                <IconButton icon="edit-1" size="medium" inline={true} inlineStyle="subtle" />
              </ToolTip>
            </Div>
        }
        {
          "SALESFORCE" === segment.type ?
            <Div className="contact-actions-button contact-actions-delete">
              <ToolTip tethered flow="up" component={"Salesforce lists cannot be deleted at this time"}>
                <IconButton disabled="true" icon="trash" size="medium" inline={true} inlineStyle="subtle" />
              </ToolTip>
            </Div>
            :
            <Div className="contact-actions-button contact-actions-delete" onClick={() => onSegmentDelete(segment.id)}>
              <ToolTip flow="up" component={"Delete segment"}>
                <IconButton icon="trash" size="medium" inline={true} inlineStyle="subtle" />
              </ToolTip>
            </Div>
        }
      </Div>
    )
  }
}

class UpdatedBy extends Component {
  render() {
    const { type, userId, updatedBy } = this.props

    if (type === 'SALESFORCE') {
      return (
        <Div className="segment-user-display">
          <IconButton disabled="true" icon="pardot" inline={true} inlineStyle="subtle" />
          <Div>Salesforce sync</Div>
        </Div>
      )
    }

    const updatedUser = updatedBy.filter((user) => user.id === userId)[0]

    if (!updatedUser) {
      return (
        <Div className="segment-user-display">
          <Avatar user={{name: 'Deleted User'}} />
          <Div>Deleted User</Div>
        </Div>
      )
    }

    const userName = updatedUser.name || updatedUser.email || updatedUser.alias

    return (
      <Div className="segment-user-display" data-private>
        <Avatar user={updatedUser} />
        <Div>{userName}</Div>
      </Div>
    )
  }
}

const TYPE_LABELS = {
  STATIC: "Static",
  DYNAMIC: "Dynamic",
  SALESFORCE: "Salesforce"
}

export default (segments, onSegmentSelect, updatedBy, setSegmentRedirect, onSegmentDelete) => (
  segments.map(segment => (
    {data: 
      [
        {
          content: (
            <Div className="segment-name-cell">
              <A onClick={() => onSegmentSelect(segment.id)}>{segment.name}</A>
            </Div>
          )
        },
        {content: TYPE_LABELS[segment.type]},
        {content: segment.size || 0},
        {content: moment(segment.updatedDate).fromNow()},
        {content: <UpdatedBy type={segment.type} userId={segment.lastUpdatedUserId} updatedBy={updatedBy} />},
        {content: <Controls segment={segment} goTo={setSegmentRedirect} onSegmentSelect={onSegmentSelect} onSegmentDelete={onSegmentDelete} />}
      ]
    }
  ))
)
